<template>
  <div class="container">
    <van-image class="page-title" :src="require('@/assets/volunteer/huigu@2x.png')"/>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onReachBottom"
    >
      <div class="list">
        <template v-for="(item, index) of list">
          <section :key="item.id" @click="onClickItem(item)">
            <div class="item">
              <van-image fit="cover" :src="item.coverImage"/>
              <div class="info">
                <div class="title">{{ item.title }}</div>
                <div class="desc">
                  <div>活动时间：{{ item.activityTime }}</div>
                  <div>活动地点：{{ item.activityLocation }}</div>
                </div>
              </div>
            </div>
            <van-divider v-if="list.length - 1 !== index" dashed hairline :style="{ borderColor: '#312925' }"/>
          </section>
        </template>
      </div>
    </van-list>
  </div>
</template>

<script>
import { getPbEducationHistory } from '@/api/educational'

export default {
  name: 'EducationalReview',
  data: () => ({
    list: [],
    loading: false,
    finished: false,
    pageNo: 1
  }),
  mounted () {
    this.review()
  },
  methods: {
    async review () {
      this.loading = true
      if (!this.finished) {
        const { result } = await getPbEducationHistory({
          pageNo: this.pageNo++
        })
        console.log(result)
        this.loading = false
        this.finished = result.current === result.pages
        this.list = [...this.list, ...result.records]
      }
    },
    onReachBottom () {
      this.review()
    },
    onClickItem (item) {
      console.log(item)
      window.location.href = item.content
      // this.$router.push('/RichText/' + item.id)
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  min-height: 100vh;
  background-color: #F3E6DD;
  overflow: hidden;

  .page-title {
    width: 250px;
    display: block;
    margin: 20px auto;
  }

  .list {
    margin: 20px;

    section {
      .item {
        width: 100%;
        display: flex;

        .van-image {
          width: 120px;
          height: 100px;
          border-radius: 8px;
          overflow: hidden;
        }

        .info {
          flex: 1;
          margin-left: 10px;
          color: #392f29;
          display: flex;
          flex-direction: column;
          justify-content: space-around;

          .title {
            font-size: 16px;
            font-weight: bold;
          }

          .desc {
            font-size: 13px;
            line-height: 1.6;
          }
        }
      }
    }
  }
}
</style>
